export default "__VITE_ASSET__CAz$20QC__"